
<workflow-no-access [workflowTargetInfo]="workflowTargetInfo"></workflow-no-access>
<div class="container" [hidden]="!workflowTargetInfo.correctRole" [ngClass]="{'general-disabled':site.isMigrationActive}">
  <div class="row alert-container-block">
    <div class="col">
      <error [error]="error"></error>
    </div>
  </div>
  <div class="row">
    <div class="col table-card">
      <list-controls [search]="searchText" [limit]="pageSize" [page]="currentPage" [numPages]="maxPages" [totalCount]="totalCount" (onChange)="onListControlsChange($event)"></list-controls>
      <table class="table table-responsive">
        <thead>
          <tr class="table-header-with-controls">
            <th>Solution</th>
            <th>DART Quantity Available</th>
            <th>Quantity Assigned to Site</th>
            <th>Quantity Assigned to Project</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let device of devices">
            <td><span class="badge badge-secondary mr-2" *ngIf="device.quicksilver">QS</span><span>{{ device.friendlyName || device.productDescription }} ({{ device.productNumber }})</span><br><span class="table-cell-sub">{{ device.dartDealId }}-{{ device.solutionId || 'NA' }}<span [hidden]="!device.preconfigurationServiceNumber"> ({{ device.preconfigurationServiceNumber }})</span></span></td>
            <td>{{ device.quantityAvailable >= 0 ? device.quantityAvailable : '' }}</td>
            <td>{{ device.quantityAssignedToSite }}</td>
            <td>{{ device.quantityAssigned }}</td>
          </tr>
          <tr *ngIf="devices.length === 0">
            <td colspan="6">
              <p class="text-center empty-table-message">There are no devices to display.</p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>